<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="669.7px"
	 height="405.3px" viewBox="0 0 669.7 405.3" style="enable-background:new 0 0 669.7 405.3;" xml:space="preserve">
<g id="pantalla_6_1_">
	<g id="XMLID_622_">
		<g id="XMLID_791_">
			<rect id="XMLID_795_" x="9.3" y="79.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_794_" x="192.8" y="79.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_793_" x="336.3" y="79.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_792_" x="499.8" y="79.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_636_">
		<g id="XMLID_784_">
			<rect id="XMLID_788_" x="9.3" y="111.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_787_" x="192.8" y="111.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_786_" x="336.3" y="111.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_785_" x="499.8" y="111.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_631_">
		<g id="XMLID_778_">
			<rect id="XMLID_782_" x="9.3" y="143.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_781_" x="192.8" y="143.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_780_" x="336.3" y="143.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_779_" x="499.8" y="143.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_656_">
		<g id="XMLID_772_">
			<rect id="XMLID_776_" x="9.3" y="175.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_775_" x="192.8" y="175.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_774_" x="336.3" y="175.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_773_" x="499.8" y="175.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_651_">
		<g id="XMLID_766_">
			<rect id="XMLID_770_" x="9.3" y="207.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_769_" x="192.8" y="207.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_768_" x="336.3" y="207.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_767_" x="499.8" y="207.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_646_">
		<g id="XMLID_763_">
			<rect id="XMLID_777_" x="9.3" y="239.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_771_" x="192.8" y="239.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_765_" x="336.3" y="239.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_764_" x="499.8" y="239.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_641_">
		<g id="XMLID_783_">
			<rect id="XMLID_800_" x="9.3" y="271.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_797_" x="192.8" y="271.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_796_" x="336.3" y="271.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_790_" x="499.8" y="271.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_672_">
		<g id="XMLID_801_">
			<rect id="XMLID_805_" x="9.3" y="303.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_804_" x="192.8" y="303.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_803_" x="336.3" y="303.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_802_" x="499.8" y="303.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_667_">
		<g id="XMLID_806_">
			<rect id="XMLID_810_" x="9.3" y="335.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_809_" x="192.8" y="335.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_808_" x="336.3" y="335.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_807_" x="499.8" y="335.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<g id="XMLID_661_">
		<g id="XMLID_811_">
			<rect id="XMLID_815_" x="9.3" y="367.3" class="st10" width="183.5" height="32"/>
			<rect id="XMLID_814_" x="192.8" y="367.3" class="st10" width="143.5" height="32"/>
			<rect id="XMLID_813_" x="336.3" y="367.3" class="st10" width="163.5" height="32"/>
			<rect id="XMLID_812_" x="499.8" y="367.3" class="st10" width="163.5" height="32"/>
		</g>
	</g>
	<rect id="XMLID_612_" x="9.3" y="4.3" class="st75" width="183.5" height="75"/>
	<rect id="XMLID_618_" x="192.8" y="4.3" class="st75" width="143.5" height="75"/>
	<rect id="XMLID_698_" x="336.3" y="4.3" class="st75" width="327" height="44"/>
	<rect id="XMLID_620_" x="336.3" y="48.3" class="st43" width="163.5" height="31"/>
	<rect id="XMLID_619_" x="499.8" y="48.3" class="st43" width="163.5" height="31"/>
	<g id="XMLID_699_">
		<rect id="XMLID_1031_" x="32.6" y="36.9" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 65.3237 48.8867)" class="st102 st273">Sustancia</text>
	</g>
	<g id="XMLID_706_">
		<rect id="XMLID_1032_" x="18.2" y="88.5" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 100.5117)" class="st102 st273">Acetileno</text>
	</g>
	<g id="XMLID_852_">
		<rect id="XMLID_1035_" x="224.4" y="87.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 252.7983 99.6133)" class="st120 st273">0,9</text>
	</g>
	<g id="XMLID_758_">
		<rect id="XMLID_1038_" x="379.1" y="87.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 99.6133)" class="st120 st273">2,5</text>
	</g>
	<g id="XMLID_745_">
		<rect id="XMLID_1041_" x="542.6" y="87.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 568.9258 99.6133)" class="st120 st273">100</text>
	</g>
	<g id="XMLID_816_">
		<rect id="XMLID_1043_" x="542.6" y="119.8" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 571.0342 131.875)" class="st120 st273">8,4</text>
	</g>
	<g id="XMLID_1070_">
		<rect id="XMLID_1044_" x="542.6" y="152" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 557.0176 164.1387)" class="st120 st273">13 a 17</text>
	</g>
	<g id="XMLID_817_">
		<rect id="XMLID_1045_" x="542.6" y="184.3" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 571.0342 196.4004)" class="st120 st273">7,6</text>
	</g>
	<g id="XMLID_1122_">
		<rect id="XMLID_1079_" x="542.6" y="216.6" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 573.1504 228.6631)" class="st120 st273">75</text>
	</g>
	<g id="XMLID_1091_">
		<rect id="XMLID_1080_" x="542.6" y="248.8" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 573.1504 260.9258)" class="st120 st273">15</text>
	</g>
	<g id="XMLID_1074_">
		<rect id="XMLID_1078_" x="542.6" y="281.1" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 573.1504 293.1875)" class="st120 st273">74</text>
	</g>
	<g id="XMLID_1024_">
		<rect id="XMLID_1064_" x="542.6" y="313.3" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 571.0342 325.4502)" class="st120 st273">7,8</text>
	</g>
	<g id="XMLID_1065_">
		<rect id="XMLID_1061_" x="542.6" y="345.6" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 571.0342 357.7129)" class="st120 st273">9,5</text>
	</g>
	<g id="XMLID_1068_">
		<rect id="XMLID_1058_" x="542.6" y="377.9" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 577.375 389.9746)" class="st120 st273">7</text>
	</g>
	<g id="XMLID_798_">
		<rect id="XMLID_1057_" x="379.1" y="119.6" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 131.7246)" class="st120 st273">1,8</text>
	</g>
	<g id="XMLID_799_">
		<rect id="XMLID_1055_" x="379.1" y="151.7" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 389.2852 163.8359)" class="st120 st273">3,8 a 6,5</text>
	</g>
	<g id="XMLID_823_">
		<rect id="XMLID_1054_" x="379.1" y="183.8" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 195.9473)" class="st120 st273">1,4</text>
	</g>
	<g id="XMLID_830_">
		<rect id="XMLID_1048_" x="379.1" y="216" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 413.875 228.0576)" class="st120 st273">4</text>
	</g>
	<g id="XMLID_859_">
		<rect id="XMLID_1046_" x="379.1" y="248.1" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 413.875 260.1689)" class="st120 st273">5</text>
	</g>
	<g id="XMLID_861_">
		<rect id="XMLID_1047_" x="379.1" y="280.2" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 403.3105 292.2793)" class="st120 st273">12,5</text>
	</g>
	<g id="XMLID_970_">
		<rect id="XMLID_1049_" x="379.1" y="312.3" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 324.3906)" class="st120 st273">1,5</text>
	</g>
	<g id="XMLID_976_">
		<rect id="XMLID_1050_" x="379.1" y="344.4" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 356.502)" class="st120 st273">2,2</text>
	</g>
	<g id="XMLID_978_">
		<rect id="XMLID_1052_" x="379.1" y="376.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 407.5342 388.6133)" class="st120 st273">1,3</text>
	</g>
	<g id="XMLID_854_">
		<rect id="XMLID_1053_" x="224.4" y="119.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 131.6133)" class="st120 st273">2,01</text>
	</g>
	<g id="XMLID_857_">
		<rect id="XMLID_1056_" x="224.4" y="184.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 247.4351 196.6133)" class="st120 st273">3 – 4</text>
	</g>
	<g id="XMLID_965_">
		<rect id="XMLID_1059_" x="224.4" y="216.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 228.6133)" class="st120 st273">0,07</text>
	</g>
	<g id="XMLID_974_">
		<rect id="XMLID_1060_" x="224.4" y="248.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 260.6133)" class="st120 st273">0,55</text>
	</g>
	<g id="XMLID_979_">
		<rect id="XMLID_1062_" x="224.4" y="280.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 292.6133)" class="st120 st273">0,97</text>
	</g>
	<g id="XMLID_985_">
		<rect id="XMLID_1063_" x="224.4" y="312.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 324.6133)" class="st120 st273">2,48</text>
	</g>
	<g id="XMLID_992_">
		<rect id="XMLID_1072_" x="224.4" y="344.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 356.6133)" class="st120 st273">1,52</text>
	</g>
	<g id="XMLID_997_">
		<rect id="XMLID_1076_" x="224.4" y="376.5" class="st226" width="77.9" height="15.5"/>
		<text transform="matrix(1 0 0 1 248.5742 388.6133)" class="st120 st273">3,14</text>
	</g>
	<g id="XMLID_831_">
		<rect id="XMLID_1081_" x="18.2" y="120.7" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 132.6631)" class="st102 st273">Butano</text>
	</g>
	<g id="XMLID_832_">
		<rect id="XMLID_1082_" x="18.2" y="152.8" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 164.8145)" class="st102 st273">Gas Natural</text>
	</g>
	<g id="XMLID_833_">
		<rect id="XMLID_1083_" x="18.2" y="185" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 196.9658)" class="st102 st273">Gasolina</text>
	</g>
	<g id="XMLID_834_">
		<rect id="XMLID_1084_" x="18.2" y="217.1" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 229.1172)" class="st102 st273">Hidrógeno</text>
	</g>
	<g id="XMLID_836_">
		<rect id="XMLID_1093_" x="18.2" y="249.3" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 261.2676)" class="st102 st273">Metano</text>
	</g>
	<g id="XMLID_838_">
		<rect id="XMLID_1127_" x="18.2" y="281.4" class="st226" width="161.1" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 293.4199)" class="st102 st273">Monóxido de Carbono</text>
	</g>
	<g id="XMLID_840_">
		<rect id="XMLID_1149_" x="18.2" y="313.6" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 325.5703)" class="st102 st273">Pentano</text>
	</g>
	<g id="XMLID_848_">
		<rect id="XMLID_1344_" x="18.2" y="345.7" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 357.7227)" class="st102 st273">Propano</text>
	</g>
	<g id="XMLID_850_">
		<rect id="XMLID_1350_" x="18.2" y="377.9" class="st226" width="137" height="15.5"/>
		<text transform="matrix(1 0 0 1 18.2085 389.873)" class="st102 st273">Tolueno</text>
	</g>
	<g id="XMLID_701_">
		<rect id="XMLID_1356_" x="208.9" y="26.6" class="st226" width="109" height="36"/>
		<text transform="matrix(1 0 0 1 229.1177 38.6367)"><tspan x="0" y="0" class="st102 st273">Densidad </tspan><tspan x="5.6" y="18" class="st102 st273">(Aire=1)</tspan></text>
	</g>
	<g id="XMLID_702_">
		<rect id="XMLID_1137_" x="406" y="10" class="st226" width="187.7" height="33.5"/>
		<text transform="matrix(1 0 0 1 417.6211 22.0117)"><tspan x="0" y="0" class="st102 st273">Límite de explosividad </tspan><tspan x="24.6" y="18" class="st102 st273">(en % Volumen)</tspan></text>
	</g>
	<g id="XMLID_703_">
		<rect id="XMLID_1097_" x="371.2" y="56.4" class="st226" width="93.8" height="14.5"/>
		<text transform="matrix(1 0 0 1 404.9922 68.3867)" class="st102 st273">LEL</text>
	</g>
	<g id="XMLID_704_">
		<rect id="XMLID_1094_" x="534.7" y="56.4" class="st226" width="93.8" height="14.5"/>
		<text transform="matrix(1 0 0 1 567.1924 68.3867)" class="st102 st273">UEL</text>
	</g>
</g>
</svg>

    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
  methods: {
    },
    mounted() {
    },
}
</script>


<style lang="scss" scoped>
	.st0{fill:none;stroke:url(#XMLID_2474_);stroke-width:2;stroke-miterlimit:10;}
	.st1{fill:#46535B;}
	.st2{fill:none;stroke:url(#XMLID_2432_);stroke-miterlimit:10;}
	.st3{fill:none;stroke:url(#XMLID_2479_);stroke-width:2;stroke-miterlimit:10;}
	.st4{fill:none;stroke:url(#XMLID_2435_);stroke-miterlimit:10;}
	.st5{fill:none;stroke:url(#XMLID_2700_);stroke-width:6;stroke-miterlimit:10;}
	.st6{fill:#ABBFC6;}
	.st7{fill:#AC7B63;}
	.st8{fill:#105477;}
	.st9{fill:#106489;}
	.st10{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st11{fill:#E0B192;}
	.st12{fill:#E0E2DE;}
	.st13{fill:none;stroke:#353535;stroke-width:2;stroke-miterlimit:10;}
	.st14{fill:#132C33;}
	.st15{fill:#E1E1E1;}
	.st16{clip-path:url(#XMLID_111_);}
	.st17{fill:none;stroke:url(#XMLID_2676_);stroke-width:6;stroke-miterlimit:10;}
	.st18{fill:url(#XMLID_2442_);stroke:#232323;stroke-miterlimit:10;}
	.st19{fill:none;stroke:url(#XMLID_2679_);stroke-width:6;stroke-miterlimit:10;}
	.st20{fill:url(#XMLID_2591_);stroke:#383838;stroke-miterlimit:10;}
	.st21{fill:#32ADF0;stroke:#32ADF0;stroke-width:11;stroke-miterlimit:10;}
	.st22{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st23{clip-path:url(#XMLID_3061_);}
	.st24{clip-path:url(#XMLID_3094_);}
	.st25{fill:url(#XMLID_2630_);stroke:#383838;stroke-miterlimit:10;}
	.st26{fill:#4C4C4C;}
	.st27{fill:#E89C2E;}
	.st28{fill:#E8B897;}
	.st29{fill:url(#XMLID_2639_);stroke:#383838;stroke-miterlimit:10;}
	.st30{filter:url(#Adobe_OpacityMaskFilter);}
	.st31{fill:none;stroke:url(#XMLID_2493_);stroke-width:2;stroke-miterlimit:10;}
	.st32{fill:none;stroke:url(#XMLID_2496_);stroke-width:2;stroke-miterlimit:10;}
	.st33{fill:#B0D882;}
	.st34{fill:none;stroke:url(#XMLID_2688_);stroke-width:6;stroke-miterlimit:10;}
	.st35{fill:none;stroke:url(#XMLID_2689_);stroke-width:6;stroke-miterlimit:10;}
	.st36{fill:none;stroke:url(#XMLID_2861_);stroke-width:5;stroke-miterlimit:10;}
	.st37{fill:none;stroke:url(#XMLID_3040_);stroke-width:4;stroke-miterlimit:10;}
	.st38{fill:none;stroke:url(#XMLID_2863_);stroke-width:5;stroke-miterlimit:10;}
	.st39{fill:none;stroke:url(#XMLID_2866_);stroke-width:5;stroke-miterlimit:10;}
	.st40{fill:none;stroke:url(#XMLID_2728_);stroke-width:6;stroke-miterlimit:10;}
	.st41{fill:#B4754D;}
	.st42{fill:url(#XMLID_2640_);stroke:#383838;stroke-miterlimit:10;}
	.st43{fill:#28F7D1;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st44{fill:#B4B4B4;}
	.st45{fill:#B50D3D;}
	.st46{opacity:0.17;fill:#1D1D1B;}
	.st47{fill:#B5B5B5;}
	.st48{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:9.0305,5.644;}
	.st49{fill:#B7B7B7;}
	.st50{fill:#1D1D1B;}
	.st51{fill:#B8BAB5;}
	.st52{fill:url(#XMLID_2441_);stroke:#383838;stroke-miterlimit:10;}
	.st53{fill:none;stroke:url(#XMLID_2870_);stroke-width:5;stroke-miterlimit:10;}
	.st54{fill:#EDEDED;}
	.st55{fill:#505154;}
	.st56{fill:url(#XMLID_2445_);stroke:#383838;stroke-miterlimit:10;}
	.st57{fill:none;stroke:url(#XMLID_2430_);stroke-width:4;stroke-miterlimit:10;}
	.st58{fill:#513B1E;}
	.st59{fill:url(#XMLID_2448_);stroke:#383838;stroke-miterlimit:10;}
	.st60{fill:#EF5A24;}
	.st61{fill:#EF8425;}
	.st62{fill:none;stroke:#969696;stroke-miterlimit:10;}
	.st63{fill:#544733;}
	.st64{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st65{fill:#54D354;}
	.st66{fill:none;stroke:url(#XMLID_2502_);stroke-width:5;stroke-miterlimit:10;}
	.st67{fill:#555555;}
	.st68{fill:#555D60;}
	.st69{fill:none;stroke:url(#XMLID_2504_);stroke-width:5;stroke-miterlimit:10;}
	.st70{fill:none;stroke:url(#XMLID_2505_);stroke-width:5;stroke-miterlimit:10;}
	.st71{fill:#56361A;}
	.st72{fill:#BAC8D1;}
	.st73{fill:#F9385D;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st74{fill:#BB8062;}
	.st75{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st76{opacity:0.58;fill:#FFFFFF;}
	.st77{fill:#2368D9;}
	.st78{fill:#23CAD9;}
	.st79{fill:url(#XMLID_2486_);stroke:#232323;stroke-miterlimit:10;}
	.st80{fill:#F4C4A4;}
	.st81{opacity:0.4;fill:#1D1D1B;}
	.st82{fill:url(#XMLID_2521_);stroke:#232323;stroke-miterlimit:10;}
	.st83{fill:#28F7D1;}
	.st84{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.5477,5.3423;}
	.st85{fill:#F7F7F7;}
	.st86{fill:#F7F8F9;}
	.st87{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.6408,4.7755;}
	.st88{fill:#5E5E5E;}
	.st89{fill:#F9385D;}
	.st90{opacity:0.35;fill:#9FEDFF;}
	.st91{fill:#C07E61;}
	.st92{fill:#C12F52;}
	.st93{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8706,4.9191;}
	.st94{fill:#C1A880;}
	.st95{fill:#939FA3;}
	.st96{fill:#93ADAD;}
	.st97{fill:#943B8A;}
	.st98{fill:#C3CDDD;}
	.st99{fill:url(#XMLID_2512_);stroke:#383838;stroke-miterlimit:10;}
	.st100{fill:#C54EB9;}
	.st101{fill:#2B2B2B;}
	.st102{font-family:'FontBase-SemiBold';}
	.st103{fill:url(#XMLID_2053_);}
	.st104{fill:url(#XMLID_2134_);}
	.st105{fill:url(#XMLID_2140_);}
	.st106{fill:url(#XMLID_2143_);}
	.st107{fill:url(#XMLID_2146_);}
	.st108{fill:url(#XMLID_2147_);}
	.st109{fill:url(#XMLID_2149_);}
	.st110{fill:url(#XMLID_2150_);}
	.st111{fill:#C7EE95;}
	.st112{fill:#C7F2E9;}
	.st113{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st114{fill:url(#XMLID_2238_);}
	.st115{fill:#99845F;}
	.st116{fill:url(#XMLID_2240_);}
	.st117{fill:url(#XMLID_2249_);}
	.st118{fill:url(#XMLID_2253_);}
	.st119{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st120{font-family:'FontBase-Regular';}
	.st121{fill:url(#XMLID_2355_);}
	.st122{fill:url(#XMLID_2356_);}
	.st123{fill:url(#XMLID_2357_);}
	.st124{fill:url(#XMLID_2359_);}
	.st125{fill:url(#XMLID_2374_);}
	.st126{fill:none;stroke:url(#XMLID_3090_);stroke-width:4;stroke-miterlimit:10;}
	.st127{fill:url(#XMLID_2425_);}
	.st128{fill:url(#XMLID_2426_);}
	.st129{fill:url(#XMLID_2427_);}
	.st130{fill:url(#XMLID_2485_);stroke:#383838;stroke-miterlimit:10;}
	.st131{fill:url(#XMLID_2431_);}
	.st132{fill:url(#XMLID_2436_);}
	.st133{fill:url(#XMLID_2437_);}
	.st134{fill:url(#XMLID_2438_);}
	.st135{fill:url(#XMLID_2439_);}
	.st136{fill:none;stroke:url(#XMLID_2771_);stroke-width:6;stroke-miterlimit:10;}
	.st137{fill:url(#XMLID_2440_);}
	.st138{fill:url(#XMLID_2443_);}
	.st139{fill:url(#XMLID_2444_);}
	.st140{fill:url(#XMLID_2449_);}
	.st141{fill:url(#XMLID_2480_);}
	.st142{fill:url(#XMLID_2481_);}
	.st143{fill:url(#XMLID_2482_);}
	.st144{fill:url(#XMLID_2483_);}
	.st145{fill:url(#XMLID_2484_);}
	.st146{fill:url(#XMLID_2487_);}
	.st147{fill:url(#XMLID_2488_);}
	.st148{fill:url(#XMLID_2491_);}
	.st149{fill:#FF3BCC;}
	.st150{fill:url(#XMLID_2506_);}
	.st151{fill:url(#XMLID_2507_);}
	.st152{fill:url(#XMLID_2508_);}
	.st153{fill:url(#XMLID_2509_);}
	.st154{fill:url(#XMLID_2510_);}
	.st155{fill:url(#XMLID_2511_);}
	.st156{fill:url(#XMLID_2522_);}
	.st157{fill:url(#XMLID_2523_);}
	.st158{fill:url(#XMLID_2489_);stroke:#383838;stroke-miterlimit:10;}
	.st159{fill:url(#XMLID_2534_);}
	.st160{fill:url(#XMLID_2535_);}
	.st161{fill:url(#XMLID_2536_);}
	.st162{fill:url(#XMLID_2537_);}
	.st163{fill:url(#XMLID_2539_);}
	.st164{fill:#FF7676;}
	.st165{fill:url(#XMLID_2540_);}
	.st166{fill:url(#XMLID_2543_);}
	.st167{fill:url(#XMLID_2544_);}
	.st168{fill:#FF88A4;}
	.st169{fill:url(#XMLID_2551_);}
	.st170{fill:url(#XMLID_2553_);}
	.st171{fill:url(#XMLID_2554_);}
	.st172{fill:url(#XMLID_2563_);}
	.st173{fill:url(#XMLID_2582_);}
	.st174{fill:url(#XMLID_2585_);}
	.st175{fill:#FFAF50;}
	.st176{fill:#FFB236;}
	.st177{fill:#FFC555;}
	.st178{fill:#FFC892;}
	.st179{fill:#FFD773;}
	.st180{fill:#FFEB99;}
	.st181{fill:#FFFF00;}
	.st182{fill:#FFFFFF;}
	.st183{fill:url(#XMLID_2542_);stroke:#232323;stroke-miterlimit:10;}
	.st184{fill:url(#XMLID_62_);}
	.st185{fill:url(#XMLID_2601_);}
	.st186{fill:url(#XMLID_2603_);}
	.st187{fill:url(#XMLID_2610_);}
	.st188{fill:url(#XMLID_2624_);}
	.st189{fill:url(#XMLID_2625_);}
	.st190{fill:url(#XMLID_2626_);}
	.st191{fill:url(#XMLID_2627_);}
	.st192{fill:url(#XMLID_2628_);}
	.st193{fill:url(#XMLID_2629_);}
	.st194{fill:url(#XMLID_2634_);}
	.st195{fill:url(#XMLID_2635_);}
	.st196{fill:url(#XMLID_2641_);}
	.st197{fill:url(#XMLID_2643_);}
	.st198{fill:url(#XMLID_2645_);}
	.st199{fill:url(#XMLID_2646_);}
	.st200{fill:url(#XMLID_2647_);}
	.st201{fill:url(#XMLID_2656_);}
	.st202{fill:url(#XMLID_2658_);}
	.st203{fill:url(#XMLID_2661_);}
	.st204{fill:url(#XMLID_2677_);}
	.st205{fill:url(#XMLID_2685_);}
	.st206{fill:url(#XMLID_2686_);}
	.st207{fill:url(#XMLID_2687_);}
	.st208{fill:url(#XMLID_2690_);}
	.st209{fill:url(#XMLID_2692_);}
	.st210{fill:url(#XMLID_2697_);}
	.st211{fill:url(#XMLID_2698_);}
	.st212{fill:none;stroke:#F9385D;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st213{fill:none;stroke:#F9385D;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st214{fill:url(#XMLID_2524_);stroke:#383838;stroke-miterlimit:10;}
	.st215{fill:url(#XMLID_2525_);stroke:#383838;stroke-miterlimit:10;}
	.st216{fill:url(#XMLID_2735_);}
	.st217{fill:url(#XMLID_2766_);}
	.st218{fill:none;stroke:url(#XMLID_2680_);stroke-width:4;stroke-miterlimit:10;}
	.st219{fill:url(#XMLID_2825_);}
	.st220{fill:url(#XMLID_2860_);}
	.st221{fill:url(#XMLID_2864_);}
	.st222{fill:url(#XMLID_2867_);}
	.st223{fill:url(#XMLID_2869_);}
	.st224{fill:url(#XMLID_2892_);}
	.st225{fill:url(#XMLID_2899_);}
	.st226{fill:none;}
	.st227{fill:none;stroke:url(#XMLID_2684_);stroke-width:4;stroke-miterlimit:10;}
	.st228{fill:url(#XMLID_2905_);}
	.st229{fill:url(#XMLID_2907_);}
	.st230{fill:url(#XMLID_2968_);}
	.st231{fill:#666461;}
	.st232{fill:none;stroke:url(#XMLID_2131_);stroke-width:5;stroke-miterlimit:10;}
	.st233{fill:#9A5F3E;}
	.st234{fill:none;stroke:url(#XMLID_2132_);stroke-width:5;stroke-miterlimit:10;}
	.st235{fill:url(#XMLID_2490_);stroke:#383838;stroke-miterlimit:10;}
	.st236{fill:#9BC16B;}
	.st237{fill:#68696D;}
	.st238{fill:none;stroke:url(#XMLID_2614_);stroke-width:6;stroke-miterlimit:10;}
	.st239{fill:#CCCCCC;}
	.st240{fill:#CCD8E2;}
	.st241{fill:#303233;}
	.st242{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8702,4.9189;}
	.st243{fill:#28F7D1;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st244{fill:#32ADF0;}
	.st245{fill:none;stroke:url(#XMLID_2141_);stroke-width:5;stroke-miterlimit:10;}
	.st246{fill:none;stroke:#BCBCBC;stroke-miterlimit:10;}
	.st247{fill:none;stroke:url(#XMLID_2144_);stroke-width:5;stroke-miterlimit:10;}
	.st248{fill:#353535;}
	.st249{fill:#353638;}
	.st250{fill:url(#XMLID_2541_);stroke:#383838;stroke-miterlimit:10;}
	.st251{fill:url(#XMLID_2545_);stroke:#383838;stroke-miterlimit:10;}
	.st252{fill:none;stroke:url(#XMLID_2805_);stroke-width:5;stroke-miterlimit:10;}
	.st253{fill:url(#XMLID_2546_);stroke:#383838;stroke-miterlimit:10;}
	.st254{fill:#003449;}
	.st255{fill:#004263;}
	.st256{fill:#006384;}
	.st257{fill:#006937;}
	.st258{fill:#008FB6;}
	.st259{fill:none;stroke:#042AB2;stroke-width:2;stroke-miterlimit:10;}
	.st260{fill:#020202;}
	.st261{fill:#D0D0D0;}
	.st262{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st263{fill:#D29472;}
	.st264{fill:#042AB2;}
	.st265{fill:none;stroke:url(#XMLID_2779_);stroke-width:5;stroke-miterlimit:10;}
	.st266{fill:url(#XMLID_107_);}
	.st267{fill:url(#XMLID_109_);}
	.st268{fill:url(#XMLID_110_);}
	.st269{fill:url(#XMLID_112_);}
	.st270{fill:url(#XMLID_113_);}
	.st271{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.7526,5.4704;}
	.st272{fill:#3A2914;}
	.st273{font-size:17;}
	.st274{fill:url(#XMLID_3022_);}
	.st275{fill:url(#XMLID_3024_);}
	.st276{fill:url(#XMLID_3042_);}
	.st277{fill:url(#XMLID_3043_);}
	.st278{fill:url(#XMLID_3045_);}
	.st279{fill:url(#XMLID_3046_);}
	.st280{fill:url(#XMLID_3048_);}
	.st281{fill:url(#XMLID_3049_);}
	.st282{fill:url(#XMLID_3050_);}
	.st283{fill:url(#XMLID_3055_);}
	.st284{fill:url(#XMLID_3056_);}
	.st285{fill:url(#XMLID_3062_);}
	.st286{fill:url(#XMLID_3063_);}
	.st287{fill:url(#XMLID_3064_);}
	.st288{fill:url(#XMLID_3066_);}
	.st289{fill:url(#XMLID_3067_);}
	.st290{fill:url(#XMLID_3078_);}
	.st291{fill:url(#XMLID_3082_);}
	.st292{fill:url(#XMLID_3083_);}
	.st293{fill:url(#XMLID_3084_);}
	.st294{fill:url(#XMLID_3087_);}
	.st295{fill:url(#XMLID_3088_);}
	.st296{fill:url(#XMLID_3089_);}
	.st297{fill:url(#XMLID_3092_);}
	.st298{fill:none;stroke:#686868;stroke-miterlimit:10;}
	.st299{fill:url(#XMLID_454_);}
	.st300{fill:#3D3D3D;}
	.st301{fill:#D82A53;}
	.st302{mask:url(#XMLID_2248_);}
	.st303{mask:url(#XMLID_2254_);}
	.st304{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.289,4.5557;}
	.st305{fill:#707070;}
	.st306{fill:none;stroke:url(#XMLID_2642_);stroke-width:6;stroke-miterlimit:10;}
	.st307{mask:url(#XMLID_2358_);}
	.st308{mask:url(#XMLID_2375_);}
	.st309{fill:none;stroke:url(#XMLID_2644_);stroke-width:6;stroke-miterlimit:10;}
	.st310{clip-path:url(#XMLID_2501_);}
	.st311{clip-path:url(#XMLID_2503_);}
	.st312{fill:none;stroke:url(#XMLID_2648_);stroke-width:6;stroke-miterlimit:10;}
	.st313{fill:none;stroke:url(#XMLID_2649_);stroke-width:6;stroke-miterlimit:10;}
	.st314{clip-path:url(#XMLID_2674_);}
	.st315{clip-path:url(#XMLID_2678_);}
	.st316{clip-path:url(#XMLID_2691_);}
	.st317{fill:#A2A599;}
	.st318{fill:#A2A7AC;}
	.st319{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st320{fill:#A4704C;}
	.st321{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.339,5.2119;}
	.st322{fill:none;stroke:url(#XMLID_3039_);stroke-width:5;stroke-miterlimit:10;}
	.st323{fill:url(#XMLID_2606_);stroke:#383838;stroke-miterlimit:10;}
	.st324{fill:url(#XMLID_2608_);stroke:#383838;stroke-miterlimit:10;}
	.st325{fill:#DA9571;}
	.st326{fill:#DB6812;}
	.st327{fill:#0D1F30;}
	.st328{fill:none;stroke:#545454;stroke-width:3;stroke-miterlimit:10;}
	.st329{fill:#A8A8A8;}
	.st330{fill:#DCFFF8;}
	.st331{fill:none;stroke:#23CAD9;stroke-miterlimit:10;}
	.st332{fill:none;stroke:url(#XMLID_2500_);stroke-width:2;stroke-miterlimit:10;}
	.st333{fill:#0F0F0F;}
	.st334{fill:#0F4B63;}
	.st335{fill:#DDE5ED;}
	.st336{fill:url(#XMLID_2597_);stroke:#232323;stroke-miterlimit:10;}
	.st337{fill:#424242;}
	.st338{fill:url(#XMLID_2632_);stroke:#232323;stroke-miterlimit:10;}
	.st339{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;}
	.st340{filter:url(#Adobe_OpacityMaskFilter_1_);}
	.st341{filter:url(#Adobe_OpacityMaskFilter_2_);}
	.st342{filter:url(#Adobe_OpacityMaskFilter_3_);}
	.st343{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st344{fill:#444444;}
	.st345{fill:none;stroke:url(#XMLID_2473_);stroke-width:2;stroke-miterlimit:10;}
</style>